<template>
  <v-container fluid fill-height style="background-color: #ffffff;">
    <v-row justify="center">
      <v-col xs="12" sm="8" md="4" lg="3" align="center">
        <v-card class="pa-5" color="transparent" elevation="0">
          <v-row style="height: 600px">
            <v-col class="d-flex align-center justify-center">
              <div v-if="authError" class="text-center">
                <v-icon color="error" size="64" class="mb-4"
                  >fas fa-exclamation-triangle</v-icon
                >
                <h3 class="error--text mb-2">Authentication Error</h3>
                <p class="text--secondary">{{ authError }}</p>
                <v-btn color="primary" @click="retryAuth" class="mt-4">
                  <v-icon left>fas fa-redo</v-icon>
                  Retry
                </v-btn>
              </div>
              <div v-else class="text-center">
                <v-progress-circular
                  color="grey lighten-2"
                  indeterminate
                  size="130"
                  width="10"
                ></v-progress-circular>

                <p class="mt-6 text--secondary">{{ loadingMessage }}</p>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { loadingMessages } from "@/constants/messages";
export default {
  data: () => {
    return {
      pid: "",
      userDealer: [],
      email: "",
      token: null,
      errorMessages: "",
      password: "",
      message: "",
      authError: null,
      loadingMessage:
        loadingMessages[Math.floor(Math.random() * loadingMessages.length)],
      authTimeout: null
    };
  },
  computed: {
    host() {
      const url = window.location.host;
      return url;
    },
    adminToken() {
      return this.$store.getters.adminToken;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
    programId() {
      return this.$store.getters.programId;
    },
    currentProgram() {
      return this.$store.getters.currentProgram;
    }
  },
  watch: {
    currentUser(value) {
      if (value) {
        this.loadingMessage = "Success!";
        // Clear any existing timeout
        if (this.authTimeout) {
          clearTimeout(this.authTimeout);
          this.authTimeout = null;
        }
        // Navigate to home after successful authentication
        setTimeout(() => {
          // Check if we're still on the demo route and not already navigating
          if (
            this.$route.name === "Demo" &&
            this.$route.path.includes("/demo")
          ) {
            this.$router.push("/home").catch(err => {
              // Only log actual errors, not navigation cancellations or duplicates
              if (
                !err.message.includes("Navigation cancelled") &&
                !err.message.includes("redundant navigation")
              ) {
                console.error("Navigation error:", err);
              }
            });
          }
        }, 1000);
      }
    },
    adminToken(value) {
      if (value) {
        this.loadingMessage =
          loadingMessages[Math.floor(Math.random() * loadingMessages.length)];
      }
    }
  },
  created() {
    this.initializeDemo();
  },
  beforeDestroy() {
    // Clean up timeout if component is destroyed
    if (this.authTimeout) {
      clearTimeout(this.authTimeout);
    }
  },
  methods: {
    async initializeDemo() {
      try {
        this.loadingMessage =
          loadingMessages[Math.floor(Math.random() * loadingMessages.length)];

        // Clean up any existing auth listeners without full logout
        this.$store.dispatch("cleanupAuthListeners");

        // Get route parameters
        this.token = this.$route.params.token;
        this.pid = this.$route.params.id;

        if (!this.token || !this.pid) {
          throw new Error("Missing demo token or program ID");
        }

        this.loadingMessage =
          loadingMessages[Math.floor(Math.random() * loadingMessages.length)];

        // Set up authentication timeout
        this.authTimeout = setTimeout(() => {
          if (!this.currentUser) {
            this.authError =
              "Preview access authentication timed out. Please try again.";
          }
        }, 30000); // 30 second timeout

        // Start authentication process
        const auth = { token: this.token, pid: this.pid };
        await this.$store.dispatch("adminAuthFirebase", auth);

        this.loadingMessage = "And away we go!";
      } catch (error) {
        console.error("Demo initialization error:", error);
        this.authError = error.message || "Failed to initialize preview access";
        this.loadingMessage = "";
      }
    },

    retryAuth() {
      this.authError = null;
      this.loadingMessage = "Retrying preview access...";
      this.initializeDemo();
    }
  }
};
</script>

<style></style>
